/* js/components/mediaPlayers/LocalMp3.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	src_url_equal
} from "svelte/internal";

import Plyr from 'plyr';
import { onMount, onDestroy } from 'svelte';

function create_if_block(ctx) {
	let audio;
	let source;
	let source_src_value;

	return {
		c() {
			audio = element("audio");
			source = element("source");
			if (!src_url_equal(source.src, source_src_value = /*src*/ ctx[0])) attr(source, "src", source_src_value);
			attr(source, "type", "audio/mp3");
			audio.controls = true;
		},
		m(target, anchor) {
			insert(target, audio, anchor);
			append(audio, source);
			/*audio_binding*/ ctx[2](audio);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 1 && !src_url_equal(source.src, source_src_value = /*src*/ ctx[0])) {
				attr(source, "src", source_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(audio);
			/*audio_binding*/ ctx[2](null);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let if_block = /*src*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "audio-container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (/*src*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { src } = $$props;
	let audioDomElement;
	let plyr;

	onMount(() => {
		const options = {
			settings: [],
			hideControls: false,
			fullscreen: { iosNative: true }
		};

		plyr = new Plyr(audioDomElement, options);
	});

	onDestroy(() => {
		if (plyr) {
			plyr.destroy();
		}
	});

	function audio_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			audioDomElement = $$value;
			$$invalidate(1, audioDomElement);
		});
	}

	$$self.$$set = $$props => {
		if ('src' in $$props) $$invalidate(0, src = $$props.src);
	};

	return [src, audioDomElement, audio_binding];
}

class LocalMp3 extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { src: 0 });
	}
}

export default LocalMp3;